import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../../assets/scss/login.scss";
import { Button, Error, Image, Label } from "../../shared/Components";
import LoginSchema from "../../shared/Schema/LoginSchema";
import Icon from "../../assets/icons/Icon";
import { loginUser, verifyOtp } from "../../store/user/user-action";
import { API_MFA_RECOVER, API_MFA_VERIFY } from "../../utils/api/ApiConstant";

const VerifyOtp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoading } = useSelector((state) => state.ui);
  const [isVerify, setIsVerify] = useState(true);
  const [error, setError] = useState("");

  const data = location?.state?.data;
  console.log("🚀 ~ VerifyOtp ~ data:", data);

  const { register, handleSubmit, setFocus, reset } = useForm({
    defaultValues: {
      mfaToken: "",
      code: "",
    },
    mode: "onTouched",
  });

  const handleValidate = (values) => {
    let message = "";

    if (!values?.code) {
      message = "Required";
    }
    // else if (values?.code.length < 6 || values?.code.length > 6) {
    //   message = "Invalid";
    // }

    setError(message);

    return message.length === 0;
  };

  const onSubmit = (values) => {
    setError("");
    const isValid = handleValidate(values);

    if (!isValid) return;

    const payload = {
      code: values?.code,
      mfaToken: data?.mfaToken,
    };

    const url = isVerify ? API_MFA_VERIFY : API_MFA_RECOVER;

    verifyOtp({ dispatch, payload, url });
  };

  return (
    <section className="body_box">
      <div className="login-part">
        <div className="logo_box">
          <Image
            src="/assets/images/logo.png"
            alt="logo"
            className="logo_img"
          />
        </div>
        <p className="titan_text">
          {isVerify ? "Verify OTP" : "Recover Account"}{" "}
        </p>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className=" input_box_card">
            <Label className="form-label" for="code">
              {isVerify ? "TOTP" : "Code"}
            </Label>
            <input
              type="number"
              className="form-control"
              id="code"
              placeholder={`Enter ${isVerify ? "totp" : "recovery code"}`}
              autoFocus
              tabIndex={1}
              {...register("code")}
            />
            {error && <Error className="error-text">{error}</Error>}
          </div>
          <button
            className="btn login-button"
            type="submit"
            isDisabled={isLoading}
            tabIndex={3}
          >
            {isLoading ? "Submitting..." : "Submit"}
          </button>
        </form>

        <Button
          className="btn login-button"
          type="button"
          onClick={() => {
            setIsVerify((prev) => !prev);
            setFocus("code", true);
            setError("");
            reset();
          }}
        >
          {isVerify ? "Recover Account" : "Verify"}
        </Button>

        <Button
          className="btn login-button"
          type="button"
          onClick={() => navigate("/login")}
        >
          Back to Login
        </Button>
      </div>
    </section>
  );
};

export default VerifyOtp;
